import {
  SET_PREVIEW_DEPARTMENT,
  SET_DUTY_INFO,
  SET_ADMIN_LIST,
  SET_REMARKS,
  SET_WEEK_ATTENDANCE,
} from './mutation-types'
import api from '@/api'
import timeUtil from '@/utils/calendar'

const state = {
  organizationId: 4, // 部门id 4 TD 6 研发 7 运维
  dutyInfo: [],
  adminList: [],
  remarks: [],
  weekAttendance: null,
}
const mutations = {
  [SET_PREVIEW_DEPARTMENT](state, payload) {
    state.organizationId = payload
  },
  [SET_DUTY_INFO](state, payload) {
    state.dutyInfo = payload
  },
  [SET_ADMIN_LIST](state, payload) {
    state.adminList = payload
  },
  [SET_REMARKS](state, payload) {
    state.remarks = payload
  },
  [SET_WEEK_ATTENDANCE](state, payload) {
    state.remarks = payload
  },
}

const actions = {
  async getDutyList({ commit }, payload) {
    let { result, code, data } = await api.deployApi.getDutyList(payload)
    if (result && code === 200) {
      // 转化时间格式
      data.map(val => {
        val.dutyDate = timeUtil.timestamp2date(val.dutyDate)
        val.createTime = timeUtil.timestamp2date(val.createTime)
        val.updateTime = timeUtil.timestamp2date(val.updateTime)
      })
      // 分类产品线
      let proLineList = []
      data.map(itm => {
        if (!proLineList[itm.type - 1]) {
          let arr = []
          arr.push(itm)
          proLineList[itm.type - 1] = arr
        } else {
          proLineList[itm.type - 1].push(itm)
        }
      })
      commit(SET_DUTY_INFO, proLineList)
    }
  },
  async addDutyAdmin({ commit }, payload) {
    let res = await api.deployApi.addDutyAdmin(payload)
    return res
  },
  async updateDutyAdmin({ commit }, payload) {
    let res = await api.deployApi.updateDutyAdmin(payload)
    return res
  },
  async queryAdminsByOrganizationIds({ commit }, payload) {
    let { result, code, data } = await api.deployApi.queryAdminsByOrganizationIds(payload)
    if (result && code === 200) commit('SET_ADMIN_LIST', data)
  },
  toggleDepartment({ commit, dispatch }, payload) {
    // commit('SET_PREVIEW_DEPARTMENT', payload)
    let arr = []
    arr.push(payload)
    dispatch('queryAdminsByOrganizationIds', { organizationIds: arr })
  },
  async queryRemarks({ commit }, payload) {
    let { result, code, data } = await api.deployApi.queryRemarks(payload)
    if (result && code === 200) commit('SET_REMARKS', data)
  },
  async addRemark({ commit }, payload) {
    let res = await api.deployApi.addRemark(payload)
    return res
  },
  async updateRemark({ commit }, payload) {
    let res = await api.deployApi.updateRemark(payload)
    return res
  },
  async synchroNailSchedule({ commit, dispatch }, payload) {
    let { code } = await api.deployApi.synchroNailSchedule(payload)
    return { code }
  },
  async getDutyTimeSlot({ commit, dispatch }, payload) {
    let { result, code, data } = await api.deployApi.getDutyTimeSlot(payload)
    if (result && code === 200) return data
  },
  async addDutyTimeSlot({ commit, dispatch }, payload) {
    let { code } = await api.deployApi.addDutyTimeSlot(payload)
    return { code }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
